import React from "react";
import { COLORS, PREDICTION_LABELS, VOTE_2022_LABELS, STATUS_LABELS } from "@/lib/constants";
import { Badge } from "@/components/ui/badge";

export function PredictionBadge({ value }) {
  if (!value) return <span className="text-muted-foreground text-xs">-</span>;
  const color = COLORS[value] || COLORS.slate;
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium"
      style={{ background: `${color}1a`, color }} data-testid={`pred-badge-${value}`}>
      <span className="status-dot" style={{ background: color }} />
      {PREDICTION_LABELS[value] || value}
    </span>
  );
}

export function StatusBadge({ value }) {
  const faal = value === "faal";
  const color = faal ? COLORS.KESIN : COLORS.BELKI;
  return (
    <span className="inline-flex items-center rounded px-2 py-0.5 text-[11px] font-semibold"
      style={{ background: `${color}1a`, color }}>
      {STATUS_LABELS[value] || value}
    </span>
  );
}

export function Vote2022Badge({ value }) {
  if (!value) return <span className="text-muted-foreground text-xs">-</span>;
  const color = COLORS[value] || COLORS.slate;
  return (
    <span className="text-xs font-medium" style={{ color }}>{VOTE_2022_LABELS[value] || value}</span>
  );
}
